import { httpClient } from "../../../../services/httpClient";

export const fetchSecurityDashboard = () => httpClient.get("/api/dashboard/security");
export const expireSecuritySession = (sessionId) =>
  httpClient.post(`/api/dashboard/security/sessions/${sessionId}/expire`, {});
export const setTemporaryPassword = (sessionId, password) =>
  httpClient.post(`/api/dashboard/security/sessions/${sessionId}/temporary-password`, {
    password_temporal: password,
  });
export const expireCampusSession = (sessionId) =>
  httpClient.post(`/api/dashboard/security/campus-sessions/${sessionId}/expire`, {});

const securityDashboardService = {
  fetch: fetchSecurityDashboard,
  expireSession: expireSecuritySession,
  setTemporaryPassword,
  expireCampusSession,
};

export default securityDashboardService;
